



































































import { Component, Vue } from 'vue-property-decorator';
import {Page} from "@/model/page";
import {messageService} from "@/services/messages";
import {Message} from "@/model/message";
import moment from "moment";
import Icon from "@/components/BrandIcon.vue";
import BrandIcon from "@/components/BrandIcon.vue";
import alertService from "@/services/alert";
import MessageSelectStatus from "@/components/MessageSelectStatus.vue";

@Component({
  components: {MessageSelectStatus, BrandIcon, Icon}
})
export default class Messages extends Vue {

  page_size = 50;
  page = 0;
  loading = true

  searchState: string[] = []
  search = ''

  messages: Page<Message> = new Page<Message>()
  stateOptions: string[] = []

  async mounted() {
    await this.loadItems();
  }

  async refresh() {
    await this.loadItems();
  }

  async loadItems()  {
    this.loading = true;
    this.messages = await messageService.findByPage(this.page,20000);
    this.stateOptions = await messageService.getStates();
    this.loading = false;
  }

  toPrettyDate(str: Date) {
    return moment(str).format('D/MM/YYYY, h:mm a');
  }

  filterItems(value: never, search: string, item: Message) {
    search = search.trim()
    const searchTerm = search.toLowerCase();
    return (item.name?.toLowerCase().includes(searchTerm) ||
      item.email?.toLowerCase().includes(searchTerm) ||
      item.userId?.toLowerCase().includes(searchTerm) ||
      item.msisdn?.toLowerCase().includes(searchTerm))
  }

  get items() {
    return this.messages.content.filter( value => (this.searchState.length === 0 || this.searchState.includes(value.state)))
  }

  get _headers() {
    return [
      {
        text: '',
        value: 'brand',
      },
      {
        text: 'Basic Info',
        align: 'start',
        value: 'basic-info',
      },
      {
        text: 'Date (DD/MM/YYYY)',
        value: 'date'
      },
      {
        text: 'Message',
        value: 'message'
      },
      {
        text: 'Subject',
        value: 'subject'
      },
      {
        text: 'State',
        value: 'state'
      },
      {
        text: '',
        value: 'open'
      }
    ];
  }
}
